import React from "react";
import { ErrorMessage } from "formik";
import { bouncy } from "ldrs";

bouncy.register();

export const DEFAULT_MAP_CENTER = { lat: 28.613939, lng: 77.209021 };

export const formatCoordinate = (value) => Number(value).toFixed(6);

export const getDefaultMapCoordinates = (currentLocation) => {
  const center = currentLocation || DEFAULT_MAP_CENTER;
  return {
    latitude: formatCoordinate(center.lat),
    longitude: formatCoordinate(center.lng),
  };
};

export const fileUploadContainerStyle = {
  display: "flex",
  alignItems: "center",
  height: "38px",
  padding: "2px 10px 2px 4px",
  border: "1px solid #ced4da",
  borderRadius: "0.375rem",
  backgroundColor: "#fff",
  overflow: "hidden",
};

export const getChooseFileButtonStyle = (isHovered) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 5,
  height: "30px",
  padding: "0 10px",
  border: "1px solid #adb5bd",
  borderRadius: "0.25rem",
  backgroundColor: isHovered ? "#e9ecef" : "#f8f9fa",
  color: "#212529",
  fontSize: 13,
  fontWeight: 400,
  cursor: "pointer",
  whiteSpace: "nowrap",
  margin: 0,
  flexShrink: 0,
  lineHeight: 1,
  transition: "background-color 0.15s ease",
});

export const fileNameTextStyle = {
  flex: 1,
  minWidth: 0,
  marginLeft: 8,
  color: "#6c757d",
  fontSize: 14,
  lineHeight: "24px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

export const cancelButtonStyle = {
  padding: "8px 20px",
  borderRadius: "4px",
  border: "1px solid #1e40af",
  background: "#ffffff",
  color: "#1e40af",
  fontSize: 14,
  fontWeight: 500,
};

export const saveButtonStyle = {
  padding: "8px 20px",
  borderRadius: "4px",
  border: "1px solid #0f172a",
  background: "#0f172a",
  color: "#ffffff",
  fontSize: 14,
  fontWeight: 500,
  minWidth: 76,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
};

export const sectionHeaderStyle = {
  backgroundColor: "rgb(235, 240, 247)",
  color: "#003366",
  padding: "8px 12px",
  borderRadius: "4px",
  fontWeight: 600,
  marginBottom: "16px",
};

export const requiredMark = <span style={{ color: "#EC1117" }}>*</span>;

export const SELECT_MENU_PORTAL_STYLES = {
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

export const COMPLAINT_IMAGE_ACCEPT =
  "image/jpeg,image/jpg,image/png,.jpg,.jpeg,.png";

export const isValidComplaintImageFile = (file) => {
  if (!file) return true;
  const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
  return (
    allowedTypes.includes(file.type) || /\.(jpe?g|png)$/i.test(file.name || "")
  );
};

export const sanitizeContactNo = (value) =>
  String(value ?? "")
    .replace(/\D/g, "")
    .slice(-10);

export const markAllFieldsTouched = (formValues) =>
  Object.keys(formValues).reduce((accumulator, key) => {
    accumulator[key] = true;
    return accumulator;
  }, {});

export const FileUploadField = ({
  label = "Upload File",
  selectedFileName,
  setSelectedFileName,
  isChooseFileHovered,
  setIsChooseFileHovered,
  setFieldValue,
}) => (
  <div className="col-md-4 mb-3">
    <label htmlFor="complaintImageFile" className="form-label">
      {label}
    </label>
    <div style={fileUploadContainerStyle}>
      <label
        htmlFor="complaintImageFile"
        style={getChooseFileButtonStyle(isChooseFileHovered)}
        onMouseEnter={() => setIsChooseFileHovered(true)}
        onMouseLeave={() => setIsChooseFileHovered(false)}
      >
        <i
          className="fa-solid fa-arrow-up-from-bracket"
          style={{ fontSize: 12 }}
        />
        Choose File
      </label>
      <span style={fileNameTextStyle} title={selectedFileName}>
        {selectedFileName}
      </span>
    </div>
    <input
      id="complaintImageFile"
      name="complaintImageFile"
      type="file"
      accept={COMPLAINT_IMAGE_ACCEPT}
      className="d-none"
      onChange={(event) => {
        const file = event.currentTarget.files?.[0] || null;
        if (file && !isValidComplaintImageFile(file)) {
          setFieldValue("complaintImageFile", null);
          setSelectedFileName("No file chosen");
          event.currentTarget.value = "";
          return;
        }
        setFieldValue("complaintImageFile", file);
        setSelectedFileName(file?.name || "No file chosen");
      }}
    />
    <ErrorMessage
      className="required-message"
      name="complaintImageFile"
      component="div"
    />
  </div>
);
